import React from 'react'
import styled from 'styled-components'

import {
  Box,
  Card,
  CardContent as MuiCardContent,
  Chip as MuiChip,
  Typography as MuiTypography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { green, grey, red } from '@material-ui/core/colors'
import { Theme } from '@material-ui/core/styles/createMuiTheme'

import { spacing } from '@material-ui/system'

const useStyles = makeStyles((theme: Theme) => ({
  percentage: {
    color: theme.palette.grey[600],
    span: {
      paddingRight: '10px',
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  up: {
    color: green[500],
  },
  down: {
    color: red[500],
  },
  steady: {
    color: grey[500],
  },
}))

const Typography = styled(MuiTypography)(spacing)

const CardContent = styled(MuiCardContent)`
  position: relative;

  &:last-child {
    padding-bottom: ${(props) => props.theme.spacing(4)}px;
  }
`

const Chip = styled(MuiChip)`
  position: absolute;
  top: 16px;
  right: 16px;
  height: 20px;
  padding: 4px 0;
  font-size: 85%;
  background-color: ${(props) => props.theme.palette.secondary.main};
  color: ${(props) => props.theme.palette.common.white};
  margin-bottom: ${(props) => props.theme.spacing(4)}px;

  span {
    padding-left: ${(props) => props.theme.spacing(2)}px;
    padding-right: ${(props) => props.theme.spacing(2)}px;
  }
`

type Direction = 'up' | 'down' | 'steady'

interface StatsProps {
  title: string
  amount: number
  chip?: string
  percentage?: string
  direction?: Direction
}

export const Stats = (props: StatsProps) => {
  const { title, amount, chip, percentage, direction = 'steady' } = props
  const classes = useStyles()
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" mb={6}>
          {title}
        </Typography>
        <Typography variant="h3" mb={6}>
          <Box fontWeight="fontWeightRegular">{amount}</Box>
        </Typography>
        {!!percentage && (
          <Typography variant="subtitle1" className={classes.percentage} mb={6}>
            <span className={classes[direction]}>{percentage}</span> Since last week
          </Typography>
        )}
        {!!chip && <Chip label={chip} />}
      </CardContent>
    </Card>
  )
}
